import { useState, useMemo, useEffect } from "react";

const PAGE_SIZE = 10;

// Modal para seleção de jazigo no cadastro de sepultamento
export default function JazigoModal({ isOpen, onClose, jazigos, onSelect }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (isOpen) { setCurrentPage(1); setSelectedIndex(null); setSearch(""); }
  }, [isOpen]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    return q ? jazigos.filter((j) => (j.codigo || "").toLowerCase().includes(q)) : jazigos;
  }, [jazigos, search]);

  const totalPages = Math.ceil((filtered.length || 0) / PAGE_SIZE);

  const currentData = useMemo(() => {
    const start = (currentPage - 1) * PAGE_SIZE;
    return filtered.slice(start, start + PAGE_SIZE);
  }, [filtered, currentPage]);

  if (!isOpen) return null;

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
    setSelectedIndex(null);
  };

  const handleSelect = (localIndex) => {
    const globalIndex = (currentPage - 1) * PAGE_SIZE + localIndex;
    setSelectedIndex(globalIndex);
  };

  const handleConfirm = () => {
    if (selectedIndex !== null) {
      onSelect(filtered[selectedIndex]);
      onClose();
    }
  };

  return (
    <div style={overlay}>
      <div style={modal}>

        {/* HEADER */}
        <div style={header}>
          <h3 style={{ margin: 0, fontSize: 15 }}>Jazigos — {filtered.length} encontrado{filtered.length !== 1 ? "s" : ""}</h3>
          <button onClick={onClose} style={closeButton}>✕</button>
        </div>

        {/* SEARCH + TABLE — área com scroll */}
        <div style={{ flex: 1, overflow: "auto" }}>
          <div style={{ padding: "10px 16px", borderBottom: "1px solid #f0f0f0" }}>
            <input
              type="text"
              placeholder="Buscar por código..."
              value={search}
              onChange={handleSearchChange}
              style={{ width: "100%", border: "none", borderBottom: "1.5px solid #e0e0e0", outline: "none", fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#444", background: "transparent", padding: "4px 0", boxSizing: "border-box" }}
            />
          </div>

          <div className="table-scroll-x">
            <table style={table}>
              <thead>
                <tr>
                  <th style={{ ...th, width: "20%" }}>ID</th>
                  <th style={{ ...th, width: "40%" }}>Setor</th>
                  <th style={{ ...th, width: "40%" }}>Código</th>
                </tr>
              </thead>
              <tbody>
                {currentData.map((jazigo, localIndex) => {
                  const globalIndex = (currentPage - 1) * PAGE_SIZE + localIndex;
                  const isSelected = globalIndex === selectedIndex;
                  return (
                    <tr
                      key={jazigo.id}
                      onClick={() => handleSelect(localIndex)}
                      onDoubleClick={() => { handleSelect(localIndex); onSelect(jazigo); onClose(); }}
                      style={{
                        background: isSelected
                          ? "rgba(242,166,108,0.25)"
                          : localIndex % 2 === 0
                          ? "rgba(242,166,108,0.07)"
                          : "#fff",
                        cursor: "pointer",
                        outline: isSelected ? "2px solid #E8956A" : "none",
                      }}
                    >
                      <td style={td}>{jazigo.id}</td>
                      <td style={td}>{jazigo.quadra}</td>
                      <td style={td}>{jazigo.codigo}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* FOOTER */}
        <div style={footer}>
          <button onClick={() => setCurrentPage((p) => p - 1)} disabled={currentPage === 1}>◀</button>

          <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "#666" }}>
            Página {currentPage} de {totalPages || 1}
          </span>

          <button onClick={() => setCurrentPage((p) => p + 1)} disabled={currentPage === totalPages || totalPages === 0}>▶</button>

          <button
            onClick={handleConfirm}
            disabled={selectedIndex === null}
            style={{ ...selectButton, opacity: selectedIndex === null ? 0.5 : 1 }}
          >
            Selecionar
          </button>
        </div>

      </div>
    </div>
  );
}

/* STYLES */

const overlay = {
  position: "fixed",
  top: 0, left: 0,
  width: "100%", height: "100%",
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modal = {
  width: "min(95vw, 500px)",
  maxHeight: "90vh",
  background: "#fff",
  borderRadius: "12px",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  display: "flex",
  flexDirection: "column",
};

const header = {
  background: "linear-gradient(135deg, #F2A66C 0%, #E8956A 100%)",
  padding: "12px 20px",
  color: "#fff",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const closeButton = {
  background: "transparent",
  border: "none",
  color: "#fff",
  fontSize: "18px",
  cursor: "pointer",
};

const table = {
  width: "100%",
  borderCollapse: "collapse",
};

const th = {
  padding: "10px",
  textAlign: "left",
  background: "#f5f5f5",
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 13,
};

const td = {
  padding: "8px 10px",
  fontSize: "14px",
  fontFamily: "'DM Sans', sans-serif",
};

const footer = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 15px",
};

const selectButton = {
  background: "#E8956A",
  border: "none",
  padding: "6px 12px",
  color: "#fff",
  borderRadius: "6px",
  cursor: "pointer",
  fontFamily: "'DM Sans', sans-serif",
};
